import _slicedToArray from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
import { setRefValue } from '../helpers/ref.js';
import { useAvailableWidth } from './useAvailableWidth.js';
import { useWidestCompositionForWidth } from './useWidestCompositionForWidth.js';
export function useWidestComposition(narrowToWideCompositionsProvider, maxWidth) {
  var _ref;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    containerElement = _useState2[0],
    setContainerElement = _useState2[1];
  var availableWidth = useAvailableWidth(maxWidth === undefined ? containerElement : null);
  var width = (_ref = maxWidth !== null && maxWidth !== void 0 ? maxWidth : availableWidth) !== null && _ref !== void 0 ? _ref : 0;
  var _useWidestComposition = useWidestCompositionForWidth(narrowToWideCompositionsProvider, width),
    items = _useWidestComposition.items,
    widestCompositionRef = _useWidestComposition.ref,
    clearCache = _useWidestComposition.clearCache;
  var ref = useCallback(function (element) {
    setRefValue(widestCompositionRef, element);
    setContainerElement(element);
  }, [widestCompositionRef]);
  return {
    items: items,
    ref: ref,
    clearCache: clearCache
  };
}